var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.221 4H5.783c-.234 0-.465.045-.681.134-.216.09-.413.22-.579.385-.165.166-.297.362-.386.579-.09.216-.137.448-.137.683v12.478c0 .165.046.328.133.468.087.141.211.255.36.329.147.074.312.105.476.09.165-.015.322-.075.454-.175l1.659-1.247c.308-.232.682-.357 1.067-.357H18.22c.234 0 .465-.046.681-.136.216-.09.412-.22.577-.386.165-.166.296-.362.386-.579.089-.216.135-.448.135-.682V5.78c0-.473-.188-.926-.522-1.26-.333-.334-.785-.521-1.257-.52zM12.89 14.477H8.444c-.295 0-.577-.118-.786-.327-.208-.209-.325-.492-.325-.788 0-.296.117-.58.325-.788.209-.21.491-.327.786-.327h4.445c.295 0 .578.118.786.327.208.209.326.492.326.788 0 .296-.117.58-.326.788-.208.21-.491.327-.786.327zm3.555-4.458h-8c-.295 0-.577-.118-.786-.327-.208-.209-.325-.492-.325-.788 0-.296.117-.58.325-.788.209-.21.491-.327.786-.327h8c.295 0 .578.117.786.327.208.209.325.492.325.788 0 .296-.117.58-.325.788-.209.21-.491.327-.786.327z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default ForwardRef;